/* tslint:disable */
/* eslint-disable */
export enum IntegrationType {
  ALOHACLOUD = 'ALOHACLOUD',
  Xpient = 'Xpient',
  MICROS3700 = 'MICROS3700',
  MICROSSIMPHONYCLOUD = 'MICROSSIMPHONYCLOUD',
  MICROSSIMPHONY = 'MICROSSIMPHONY',
  POSITOUCH = 'POSITOUCH',
  NONINTEGRATED = 'NONINTEGRATED',
  RAVEL = 'RAVEL',
  SAREST = 'SAREST',
  Simphony = 'Simphony',
  Compris = 'Compris',
  SpeedLine = 'SpeedLine',
  BRINK = 'BRINK',
}
